import script from "./PasswordLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordLayout.vue?vue&type=script&setup=true&lang=js"

import "./PasswordLayout.vue?vue&type=style&index=0&id=e25bfe7e&lang=css"

const __exports__ = script;

export default __exports__